import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CadastrarAvaliacaoLayer from "../components/CadastrarAvaliacaoLayer";
import { useTranslation } from "../i18n/I18nContext";

const CadastrarAvaliacaoPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("avaliacao.breadcrumb.create")} />
      <CadastrarAvaliacaoLayer />
    </MasterLayout>
  );
};

export default CadastrarAvaliacaoPage;
